import revive_payload_client_4sVQNw7RlN from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_client_LcKgStRyi6 from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/node_modules/nuxt-gtag/dist/runtime/plugin.client.mjs";
import plugin_C2QvvtgUo3 from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/node_modules/@dargmuesli/nuxt-cookie-control/dist/runtime/plugin.js";
import plugin_RdadCF4ArJ from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/node_modules/nuxt-aos/dist/runtime/plugin.mjs";
import i18n_yfWm7jX06p from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import chunk_reload_client_UciE0i6zes from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_1UohGbtF8v from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/node_modules/@pinia-plugin-persistedstate/nuxt/dist/runtime/plugin.mjs";
import externalImage_wgH76rL1Xm from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/plugins/externalImage.ts";
import lottie_client_MJBevkcINk from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/plugins/lottie.client.ts";
import mediumzoom_client_dhULvDV4Q3 from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/plugins/mediumzoom.client.ts";
import sentry_client_shVUlIjFLk from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/plugins/sentry.client.ts";
import splide_client_vtWLhI3hb1 from "/Users/jnieto/Projects/web-reborn/nuxt3-reborn_copy/plugins/splide.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_client_LcKgStRyi6,
  plugin_C2QvvtgUo3,
  plugin_RdadCF4ArJ,
  i18n_yfWm7jX06p,
  chunk_reload_client_UciE0i6zes,
  plugin_1UohGbtF8v,
  externalImage_wgH76rL1Xm,
  lottie_client_MJBevkcINk,
  mediumzoom_client_dhULvDV4Q3,
  sentry_client_shVUlIjFLk,
  splide_client_vtWLhI3hb1
]